// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__FjLip","spinner-rotate":"spinner_spinner-rotate__AULPr"};